import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { PAGINATION, MAX_PAGES_NUMBER } from 'config/constants';
import { range } from 'utils/helpers';
import PaginationOptions from 'utils/domain/PaginationOptions';
import { FormattedMessage } from 'ui/i18n';

import './Pagination.scss';

export default class Pagination extends Component {
	static propTypes = {
		pagination: PropTypes.shape({
			page: PropTypes.number,
			size: PropTypes.number,
		}).isRequired,
		onPaginationChange: PropTypes.func.isRequired,
		count: PropTypes.number,
	};

	static defaultProps = {
		count: 1,
	};

	onPageChange(page, e) {
		e.preventDefault();
		if (page === this.props.pagination.page || this.getPageCount() === 1) {
			return;
		}

		this.props.onPaginationChange(
			new PaginationOptions(this.getPageNum(page), this.props.pagination.size)
		);
		window.scrollTo(0, 0);
	}

	onPageSizeChange(e) {
		this.props.onPaginationChange(
			new PaginationOptions(1, parseInt(e.target.value, 10))
		);
		window.scrollTo(0, 0);
	}

	onPageOptionChange(e) {
		const page = parseInt(e.target.value, 10);

		this.props.onPaginationChange(
			new PaginationOptions(this.getPageNum(page), this.props.pagination.size)
		);
		window.scrollTo(0, 0);
	}

	getPageCount() {
		return Math.ceil(
			this.props.count / parseInt(this.props.pagination.size, 10)
		);
	}

	getPageNum(page) {
		const current_page = this.props.pagination.page;
		const page_count = this.getPageCount();

		switch (page) {
			case 'prev':
				return current_page === 1 ? page_count : current_page - 1;
			case 'next':
				return current_page === page_count ? 1 : current_page + 1;
			default:
				return page;
		}
	}

	render() {
		const { pagination: { page: current_page, size } } = this.props;
		const page_count = this.getPageCount();

		return (
			<div className="Pagination form-inline">
				<div className="Pagination-size form-group">
					<label className="PaginationLabel">
						<FormattedMessage id="itemsTable.resultsPerPage" />
					</label>
					<select
						className="Pagination-size-control form-control"
						value={size}
						onChange={this.onPageSizeChange.bind(this)}
					>
						{PAGINATION.sizes.map(size =>
							<option key={size} value={size}>
								{size}
							</option>
						)}
					</select>
				</div>

				<nav className="pull-right">
					<ul className="pagination">
						<li className={page_count === 1 ? 'disabled' : ''}>
							<a
								href="#"
								aria-label="Previous"
								onClick={this.onPageChange.bind(this, 'prev')}
								className="Pagination-prev"
							>
								<span aria-hidden="true">«</span>
							</a>
						</li>

						{page_count >= MAX_PAGES_NUMBER
							? <li>
									<select
										className="form-control"
										value={current_page}
										onChange={this.onPageOptionChange.bind(this)}
									>
										{range(1, page_count + 1).map(page =>
											<option key={page} value={page}>
												{page}
											</option>
										)}
									</select>
								</li>
							: range(1, page_count + 1).map(page =>
									<li
										key={page}
										className={page === current_page ? 'active' : ''}
									>
										<a
											href="#"
											className={`Pagination__Page--${page}`}
											onClick={this.onPageChange.bind(this, page)}
										>
											{page}
										</a>
									</li>
								)}

						<li className={page_count === 1 ? 'disabled' : ''}>
							<a
								href="#"
								aria-label="Next"
								onClick={this.onPageChange.bind(this, 'next')}
								className="Pagination-next"
							>
								<span aria-hidden="true">»</span>
							</a>
						</li>
					</ul>
				</nav>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/ui/components/Pagination/index.js